"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConversationsOption_1 = require("owa-conversations-option/lib/ConversationsOption");
var DateHeadersOption_1 = require("owa-date-headers-option/lib/DateHeadersOption");
var FocusedInboxOption_1 = require("owa-focused-option/lib/FocusedInboxOption");
var InlinePreviewsOption_1 = require("owa-inline-previews-option/lib/InlinePreviewsOption");
var SenderImageOption_1 = require("owa-sender-image-option/lib/SenderImageOption");
var MessagePreviewOption_1 = require("owa-message-preview-option/lib/MessagePreviewOption");
var ReadingPaneOption_1 = require("owa-reading-pane-option/lib/ReadingPaneOption");
var SenderSubjectOption_1 = require("owa-sender-subject-option/lib/SenderSubjectOption");
var layoutSubCategory = {
    key: 'layout',
    titleStringKey: 'optionSubcategory_layout',
    options: [
        ConversationsOption_1.default,
        FocusedInboxOption_1.default,
        SenderSubjectOption_1.default,
        MessagePreviewOption_1.default,
        SenderImageOption_1.default,
        ReadingPaneOption_1.default,
        InlinePreviewsOption_1.default,
        DateHeadersOption_1.default,
    ],
};
exports.default = layoutSubCategory;
//# sourceMappingURL=layoutSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/layoutSubCategory.js
// module id = 5064
// module chunks = 2